import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Box,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import { deleteinvoice } from "../services/dataService";
import { toast } from "react-toastify";
import { getInvoiceDetails } from "../services/dataService";
import { GET_GENERATED_INVOICES } from "../store/ActionType";
import { dispatcher } from "../store/helper";
import { Sendmailinvoicedelete } from "../services/dataService";
const Invoicedelete = ({
  InvoiceID,
  Invoicenumber,
  handleClose,
  fromDate,
  toDate,
  setpopid,
}) => {
  const [remark, setremark] = useState("");
  const [isloading, setisLoading] = useState(false);

  const refreshinvoicedetails = async () => {
    try {
      const response = await getInvoiceDetails({
        FromDate: fromDate,
        ToDate: toDate,
      });

      dispatcher(GET_GENERATED_INVOICES, response.data);
    } catch (e) {}
  };

  const handledeletesubmit = async () => {
    const payload = { InvoiceID, remark };
    setisLoading(true);
    if (remark) {
      try {
        const mailresponse = await Sendmailinvoicedelete(payload);
        toast.success(mailresponse.data);
        const response = await deleteinvoice(payload); 
        toast.success(response.data.Message);
        setisLoading(false);
        handleClose();
        setpopid(null);
        setremark("");
        refreshinvoicedetails();
  
      } catch (error) {
        setisLoading(false)
        handleClose();
        setremark("");
        toast.error(error.response.data.Message || error.response.data.message);
      }
    } else {
      setisLoading(false);
      toast.error("Please enter reason");
    }
  };
  return (
    <>
      <Dialog
        open={Boolean(Invoicenumber)}
        onClose={handleClose}
        sx={{
          position: "center",
          right: 8,
          top: 8,
        }}
      >
        <DialogTitle sx={{ ml: 0 }}>
          {"Delete Invoice " + Invoicenumber}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            {" "}
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            pt: "0px !important",
          }}
        >
          <label className="starlabel" style={{ fontSize: "13px" }}>
            Reason<span className="starlabel"></span>
          </label>
          <Box>
            <textarea
              style={{
                width: "310px",
                resize: "none",
                height: "60px",
                outline: "none",
              }}
              onChange={(e) => {
                setremark(e.target.value);
              }}
            ></textarea>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} sx={{ fontSize: "10px" }}>
            Close
          </Button>
          <Button
            variant="contained"
            //onClick={onclick}
            sx={{ fontSize: "10px" }}
            //disabled={isLoading}
            color="primary"
            onClick={handledeletesubmit}
            disabled={isloading}
          >
            {isloading ? "Deleting.." : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Invoicedelete;
